import React from 'react';

export const BaseStagePlugin = React.forwardRef<
    HTMLDivElement,
    {
        name?: string;
        children: React.ReactNode;
        /** 是否启用事件，默认 false */
        enablePointerEvents?: boolean;
        /** 自定义样式 */
        style?: React.CSSProperties;
        zIndex?: number;
    }
>(({ name, children, enablePointerEvents, style, zIndex }, ref) => {
    const stylePointerEvents: React.CSSProperties = enablePointerEvents ? { pointerEvents: 'initial' } : {};
    const styleZIndex: React.CSSProperties = zIndex ? { zIndex: zIndex } : {};
    return (
        <div
            ref={ref}
            className="editor-plugin"
            data-plugin={name}
            style={{ ...style, ...stylePointerEvents, ...styleZIndex }}
        >
            {children}
        </div>
    );
});

BaseStagePlugin.displayName = 'BaseStagePlugin';
